// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:M6Ni5- */\n.wx444{display:flex;gap:var(--audio-spacing-12);padding:var(--audio-spacing-12)}.rnth9{flex-shrink:0;height:56px;position:relative;width:56px}._1cDV7{height:56px;position:absolute;width:56px}.EurzA{display:flex;flex-direction:column;flex-grow:1;gap:var(--audio-spacing-8);justify-content:center;min-width:0}.rUvsD{height:20px;width:70%}.GnsFr{height:14px;width:40%}.pEM6I{display:none}@media (min-width:768px){.wx444{gap:var(--audio-spacing-24);padding:var(--audio-spacing-32) var(--audio-spacing-24)}.rnth9,._1cDV7{height:140px;width:140px}.rUvsD{height:24px}.pEM6I{display:block;height:60px;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "wx444",
	"coverBox": "rnth9",
	"coverImage": "_1cDV7",
	"main": "EurzA",
	"title": "rUvsD",
	"author": "GnsFr",
	"body": "pEM6I"
};
export default ___CSS_LOADER_EXPORT___;
